// src/pages/SuiviCommande.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const STATUS_KEYS = ['pending', 'confirmed', 'prepared', 'shipped', 'delivered'];

function SuiviCommande() {
  const { t, i18n } = useTranslation();

  const [orderNumber, setOrderNumber] = useState('');
  const [phone, setPhone] = useState('');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setOrder(null);

    try {
      const { data } = await axios.get(
        `https://madadline.com/api/orders/${orderNumber}`,
        { params: { phone } }
      );
      setOrder(data);
    } catch (err) {
      setError(t('track.errorNotFound'));
    } finally {
      setLoading(false);
    }
  };

  const currentStepIndex = order
    ? STATUS_KEYS.indexOf(order.status || 'pending')
    : 0;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const locale = i18n.language === 'ar' ? 'ar-MA' : i18n.language === 'en' ? 'en-GB' : 'fr-FR';
    try {
      return new Date(dateStr).toLocaleDateString(locale);
    } catch {
      return new Date(dateStr).toLocaleDateString();
    }
  };

  return (
    <main className="track-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('track.heroLabel')}</span>
          <h1 className="page-hero__title">{t('track.heroTitle')}</h1>
          <p className="page-hero__subtitle">{t('track.heroSubtitle')}</p>
        </div>
      </header>

      <section className="track-content">
        <form className="track-form" onSubmit={handleSubmit}>
          <div className="track-form__group">
            <label htmlFor="orderNumber">{t('track.labelOrder')}</label>
            <input
              id="orderNumber"
              type="text"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              placeholder={t('track.placeholderOrder')}
              required
            />
          </div>
          <div className="track-form__group">
            <label htmlFor="phone">{t('track.labelPhone')}</label>
            <input
              id="phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder={t('track.placeholderPhone')}
              required
            />
          </div>
          <button type="submit" className="track-form__submit" disabled={loading}>
            {loading ? t('track.searching') : t('track.submit')}
          </button>
        </form>

        {error && <div className="track-error">{error}</div>}

        {order && (
          <div className="track-result">
            <div className="track-result__head">
              <h2>{t('track.orderTitle', { id: order.id })}</h2>
              <span className="track-result__date">
                {formatDate(order.created_at)}
              </span>
            </div>

            <div className="track-timeline">
              {STATUS_KEYS.map((key, i) => (
                <div key={key} className={`track-step ${i <= currentStepIndex ? 'is-done' : ''}`}>
                  <div className="track-step__dot">
                    {i <= currentStepIndex && '✓'}
                  </div>
                  <span className="track-step__label">{t(`track.status.${key}`)}</span>
                </div>
              ))}
            </div>

            <p className="track-info">
              {t('track.question')}{' '}
              <a href="https://wa.me/212669428878" target="_blank" rel="noreferrer">
                {t('track.whatsapp')}
              </a>
            </p>
          </div>
        )}
      </section>
    </main>
  );
}

export default SuiviCommande;